import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { EnvBannerComponent } from './core/env-banner.component';
import { FeaturesModule } from './features/features.module';
import { AppRoutes } from './app.routes';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [AppComponent, EnvBannerComponent],
  imports: [
    CoreModule,
    BrowserModule,
    FeaturesModule,
    AppRoutes,
    SharedModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
